export default "__VITE_ASSET__d89a50c6__"